<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->



document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion");

  accordions.forEach((accordion) => {
    accordion.addEventListener("click", function () {
      this.classList.toggle("active");

      const panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
});



/* =============================================================================
   Product-page gallery: show the Product-Labels app ribbon (MALE / FEMALE
   gender tag) on the FIRST gallery image only. Hide it on every other gallery
   image (lifestyle shots, the trust/review image, extra shots, etc.).
   Collection / listing cards are untouched (they have no [data-media-id]).
   Label markup: [data-media-id] slide  ->  [data-lably-placement] (app label).
   ============================================================================= */
(function () {
  function idTail(el) { var m = (el.getAttribute('data-media-id') || '').match(/(\d+)$/); return m ? m[1] : ''; }
  function keepSet() {
    // media ID of the first ORIGINAL (non-clone) gallery slide: slick index 0
    var keep = {};
    var slides = document.querySelectorAll('[data-media-id]');
    for (var i = 0; i < slides.length; i++) {
      var sl = slides[i].closest('[data-slick-index]');
      if (sl && !sl.classList.contains('slick-cloned') && sl.getAttribute('data-slick-index') === '0') {
        keep[idTail(slides[i])] = true;
      }
    }
    // fallback: if slick indices aren't available, keep the first media in DOM order
    if (!Object.keys(keep).length && slides.length) { keep[idTail(slides[0])] = true; }
    return keep;
  }
  function applyRule() {
    var slides = document.querySelectorAll('[data-media-id]');
    if (!slides.length) return; // not a product gallery page
    var keep = keepSet();
    var labels = document.querySelectorAll('[data-lably-placement]');
    for (var i = 0; i < labels.length; i++) {
      var slide = labels[i].closest('[data-media-id]');
      if (!slide) continue; // outside the PDP gallery (e.g. collection card) -> leave alone
      labels[i].style.display = keep[idTail(slide)] ? '' : 'none';
    }
  }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { scheduled = false; applyRule(); }, 0);
  }
  function start() {
    applyRule();
    if (document.body && window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
  window.addEventListener('load', applyRule);
})();




